import React, { FunctionComponent } from 'react';
import { calendarIcon, inMemoryIcon, teamIcon } from '@justgiving/icons';
import IconType from '../../constants/iconTypes';
import './Reason.scss';
import { Reason as ReasonType } from '../../../types/__generated__';
import IconLabel from '../IconLabel/IconLabel';
import { Occasion } from '../Occasion/Occasion';
import { useBasePageQuery } from '../../hooks';

const iconMap = {
  [IconType.CalendarIcon]: calendarIcon,
  [IconType.InMemoryIcon]: inMemoryIcon,
  [IconType.TeamIcon]: teamIcon,
};

export const Reason: FunctionComponent = () => {
  const { data } = useBasePageQuery();

  if (!data?.page) {
    return null;
  }

  const { reason, occasion } = data.page;

  if (occasion) {
    return <Occasion />;
  }

  if (!reason) {
    return null;
  }

  const icon = reason.icon ? iconMap[reason.icon] : '';

  return (
    <div data-qa="reason-details">
      <IconLabel icon={icon} label={renderReason(reason)} />
    </div>
  );
};

function renderReason(reason: ReasonType): string | JSX.Element {
  if (!reason.reasonUrl) {
    return reason.reason ?? '';
  }

  return <a href={reason.reasonUrl}>{reason.reason}</a>;
}

export default Reason;
